//
// Bonus Multiview Collection
// --------------------------

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var BaseCollection = require('common/base.collection');
    var BonusMultiviewBonusModel = require('portlets/bonus-multiview/bonusmultiview.bonus.model');
    var server = require('server');
    var user = require('user');
    var config = require('config');
    var bonusMixin = require('mixins/bonus.mixin');

    return BaseCollection.extend({

        mixins: [bonusMixin],

        model: BonusMultiviewBonusModel,

        comparator: 'order',

        _bonusMetaInfo: {
            'FREE': { actionTitle: 'playtech.mobile.system.getFreeBonus', type: 'free' },
            'OPT_IN': { actionTitle: 'playtech.mobile.system.optIn', type: 'optIn' },
            'OPT_OUT': { actionTitle: 'playtech.mobile.system.optOut', type: 'optOut' },
            'BUY_IN': { actionTitle: 'playtech.mobile.system.buyIn', type: 'buyIn' },
            'FREE_SPINS': { actionTitle: 'playtech.mobile.system.freespin', type: 'freespin' },
            'DEPOSIT': { actionTitle: 'playtech.mobile.system.deposit', type: 'deposit' },
            'SIGN_UP': { actionTitle: 'playtech.mobile.system.login.button.join_now', type: 'join_now' },

            'LOGIN': { actionTitle: 'playtech.mobile.system.login.button.login', type: 'login' },
            'GOLDEN_CHIPS': { actionTitle: 'playtech.mobile.system.goldenChips', type: 'goldenChips' },
            'CUSTOM': { actionTitle: '', type: 'custom' },
            'CAMPAIGN': { actionTitle: '', type: 'campaign' }
        },

        bonusTriggers: ['SIGN_UP', 'FREE_SPINS', 'CUSTOM', 'GOLDEN_CHIPS', 'CAMPAIGN'],
        bonusTypes: ['optIn', 'buyIn', 'free', 'deposit', 'campaign'],

        initialize: function(models, options) {
            this.options = options;
            /**
             * BE bonus configs
             * @type {Array}
             */
            this.bonusesConfig = config.get('bonusesConfiguration') || [];
            this.bonusesPrefs = config.get('bonusManagementPreferences');
            this._addBonusTypes();

        },

        subscribe: function() {
            this.on('change:type', this.toggleOptBonus);
            this.listenTo(core, 'bonus-multiview:toggleBonus', this.handleOptToggling, this);
        },

        _addBonusTypes: function() {

            _.each(this.bonusesConfig, function(bonus) {
                const { bonusCode, bonusTrigger } = bonus;

                _.extend(bonus, this._bonusMetaInfo[bonusTrigger]);

                if (bonusTrigger === 'CUSTOM' || bonusTrigger === 'CAMPAIGN') {
                    const bonusType = bonusTrigger === 'CUSTOM' ? 'custombonus' : 'campaignbonus';

                    bonus.actionTitle = user.isLoggedIn()
                        ? `playtech.mobile.system.bonus.${bonusCode}.${bonusType}.logged-in`
                        : `playtech.mobile.system.bonus.${bonusCode}.${bonusType}.logged-out`;
                }
            }, this);
        },

        /**
         * Filter bonuses, merge IMS bonus templates with BE bonus configs
         * @param response - from IMS
         * @param options - Backbone sync options
         * @returns {Array}
         */
        parse: function(response, options) {
            var filteredBonusesConfig = this.getFilteredBonusesConfig();
            var savedOrder = filteredBonusesConfig.map(function(bonus) { return bonus.bonusCode; });
            var result;

            if (user.isLoggedIn()) {
                this.setBonusesTitle(response.bonuses);

                result = this._mergeBonusesWithConfig(response.bonuses, filteredBonusesConfig);

                this._setOptOutBonuses(result, response.optInList);
                this._addConfigBonuses(result, filteredBonusesConfig);
            } else {
                result = filteredBonusesConfig;
                this._changeButtonsToLogin(result);
            }

            // prevent BonusModel from parsing already parsed data
            options.parse = false;
            // return original order
            this._filterByExistOrder(result, savedOrder);

            return result;
        },

        _filterByExistOrder: function(bonuses, order) {
            var move = function(array, from, to) {
                var element = array[from];
                array.splice(from, 1);
                array.splice(to, 0, element);
            };

            order.forEach(function(code, index) {
                var position = _.findIndex(bonuses, function(bonus) {
                    return bonus.bonusCode === code;
                });
                if (position !== -1) {
                    move(bonuses, position, index);
                }
            });
        },

        setBonusesTitle: function(bonuses) {
            bonuses.forEach(function(bonus) {
                bonus.title = this.setBonusName(bonus);
            }.bind(this));
        },

        /**
         * @param bonuses - from IMS
         * @param bonusesConfig - from BE
         */
        _mergeBonusesWithConfig: function(bonuses, bonusesConfig) {
            var bonusCfg;
            return bonuses.filter(function(bonus) {
                bonusCfg = _.findWhere(bonusesConfig, { bonusCode: bonus.code });
                if (bonusCfg) {
                    _.extend(bonus, _.omit(bonusCfg, 'code'));
                    return true;
                }
                return false;
            });
        },

        _setOptOutBonuses: function(bonuses, optInList) {
            var bonus;
            _.each(optInList, function(optInInfo) {
                bonus = _.findWhere(bonuses, { bonusCode: optInInfo.templateCode });
                if (bonus) {
                    bonus.bonusTrigger = 'OPT_OUT';
                    _.extend(bonus, this._bonusMetaInfo[bonus.bonusTrigger]);
                }
            }.bind(this));
        },

        /**
         * @param bonuses - from IMS
         * @param bonusesCfg - from BE
         * @private
         */
        _addConfigBonuses: function(bonuses, bonusesCfg) {
            bonusesCfg.forEach(function(bonus) {
                if (bonus.bonusTrigger === 'FREE_SPINS'
                    || bonus.bonusTrigger === 'CUSTOM'
                    || bonus.bonusTrigger === 'GOLDEN_CHIPS'
                    && !_.findWhere(bonuses, { bonusCode: bonus.bonusCode })) {

                    bonuses.push(bonus);
                }
            });
        },

        _changeButtonsToLogin: function(bonuses) {
            bonuses.forEach(function(bonus) {
                if (!this.bonusTriggers.includes(bonus.bonusTrigger)) {
                    _.extend(bonus, this._bonusMetaInfo.LOGIN);
                }
            }.bind(this));
        },

        _filterByPresentation: function(bonus) {
            if (this.options.showAll) {
                return true;
            }
            return _.contains(this.options.bonusCodes, bonus.bonusCode);
        },

        _filterByUserSegmentation: function(bonus) {
            var filterByLoggedIn = bonus.showFor === 'BOTH' || user.isLoggedIn() !== (bonus.showFor === 'LOGGED_OUT');
            var filterBySignUp = !(user.get('hasBeenLoggedIn') && bonus.bonusTrigger === 'SIGN_UP');

            return filterByLoggedIn && filterBySignUp;
        },

        getFilteredBonusesConfig: function() {
            if (user.isAdmin()) {
                return this.bonusesConfig;
            }

            return _.filter(this.bonusesConfig, function(bonus) {
                return this._filterByUserSegmentation(bonus) && this._filterByPresentation(bonus);
            }.bind(this));
        },

        _requestOptInList: function() {
            return server.send({
                ID: 31068,
                description: 'Get list of opted-in bonuses',
                responses: [31069],
                returnBonusTemplateDetails: true,
                returnWageringCoefficients: false
            });
        },

        _getBonusTypes: function(bonusesCfg) {
            return _.filter(this.bonusTypes, function(type) {
                return _.findWhere(bonusesCfg, { type: type });
            });
        },

        _requestBonusList: function(bonusTypes) {
            var request = {
                ID: 31143,
                responses: [31144, 31145],
                description: 'Search Player Available Bonus Templates',
                triggerTypes: []
            };
            var promoCodes = [];

            bonusTypes.forEach(function(bonusType) {
                switch (bonusType) {
                    case 'free':
                        if (this.bonusesPrefs.bonusFreeCode && this.bonusesPrefs.bonusFreeCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusFreeCode);
                        }
                        break;
                    case 'optIn':
                        if (this.bonusesPrefs.bonusOptInCode && this.bonusesPrefs.bonusOptInCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusOptInCode);
                        }
                        break;
                    case 'buyIn':
                        request.triggerTypes.push('buybonus');
                        break;
                    case 'deposit':
                        request.triggerTypes.push('deposit');
                        break;
                    case 'campaign':
                        request.triggerTypes.push('campaign');
                        break;
                }
            }.bind(this));

            if (promoCodes.length) {
                request.triggerTypes.push('promotioncode');

                if (promoCodes.length > 1) {
                    return $.when(
                        server.send({ ...request, promotionCode: promoCodes[0] }),
                        server.send({ ...request, promotionCode: promoCodes[1] })
                    );
                }

                return server.send(_.extend(request, { promotionCode: promoCodes[0] }));
            }

            return server.send(request);
        },

        // Get bonuses from IMS
        sync: function(method, collection, options) {
            var syncState = $.Deferred();
            syncState.then(options.success, options.error);

            if (method !== 'read') {
                core.error('Method "' + method + '" unsupported.');
                return syncState.reject();
            }

            var filteredBonusesConfigs = this.getFilteredBonusesConfig();
            var bonusIds = options.bonusIds;
            var result = {
                optInList: [],
                bonuses: []
            };
            var bonusTypes, isOptInRequestNeeded;

            if (bonusIds) {
                filteredBonusesConfigs = this._getBonusConfigsByIds(bonusIds, filteredBonusesConfigs);
            }

            if (!filteredBonusesConfigs.length || !user.isLoggedIn()) {
                return syncState.resolve(result);
            }

            bonusTypes = this._getBonusTypes(filteredBonusesConfigs);
            if (!bonusTypes.length) {
                return syncState.resolve(result);
            }

            isOptInRequestNeeded = bonusTypes.indexOf('optIn') !== -1;

            $.when(
                this._requestBonusList(bonusTypes),
                isOptInRequestNeeded ? this._requestOptInList() : null
                )
                .done(function(bonusDetails, optIns) {
                    result.bonuses = _.isArray(bonusDetails)
                        ? bonusDetails[0].data.matchingBonusTemplates.concat(bonusDetails[1].data.matchingBonusTemplates)
                        : bonusDetails.data.matchingBonusTemplates;

                    if (optIns) {
                        result.optInList = optIns.data.bonusTemplateOptIns;
                    }

                    syncState.resolve(result);
                })
                .fail(function() {
                    syncState.reject();
                });

            return syncState;
        },

        _getBonusConfigsByIds: function(bonusIds, bonusesCfg) {
            bonusIds = bonusIds.map(function(id) {
                return String(id);
            });

            return bonusesCfg.filter(function(bonusCfg) {
                return bonusIds.indexOf(bonusCfg.bonusCode) !== -1;
            });
        },

        /**
         * Trigger event for other bonus-multiview portlets
         * @param  {Model} model - bonus model
         */
        toggleOptBonus: function(model) {
            core.trigger('bonus-multiview:toggleBonus', model.toJSON());
        },

        /**
         * Toggle model type
         * @param {Model} bonus - bonus model
         */
        handleOptToggling: function(bonus) {
            var model = this.get(bonus.bonusCode);

            if (model && model.get('type') !== bonus.type) {
                model.set({
                    type: bonus.type,
                    actionTitle: 'playtech.mobile.system.' + bonus.type,
                    silent: true
                });
            }
        }

    });
});
